export default "__VITE_ASSET__CSFuMI9B__"